import { middleware } from 'vue-router-middleware'

export default [
    {
        name: 'login',
        path: '/login',
        meta: { layout: 'base', title: 'Iniciar sesión' },
        component: () => import('@/views/usuario/Login')
    },
    {
        name: 'password_recovery',
        path: '/password-recovery',
        meta: { title: 'Recuperar contraseña', layout: 'base' },
        component: () => import('@/views/usuario/PasswordRecovery')
    },
    {
        name: 'password_reset',
        path: '/password-reset/:hash',
        meta: { title: 'Reestablecer contraseña', layout: 'base' },
        component: () => import('@/views/usuario/PasswordReset')
    },
    ...middleware(['auth-required'], [
        {
            name: 'dashboard',
            path: '/',
            meta: { title: 'Dashboard' },
            component: () => import('@/views/Dashboard')
        },
        {
            name: 'promotor',
            path: '/promotor/:promotor',
            meta: { title: 'Promotor' },
            component: () => import('@/views/promotor/Promotor')
        },
        {
            name: 'actividad',
            path: '/actividad',
            meta: { title: 'Actividad' },
            component: () => import('@/views/actividades/ActividadList')
        },
        {
            name: 'examenes',
            path: '/examenes',
            meta: { title: 'Examenes' },
            component: () => import('@/views/examen/Examenes')
        },
        {
            name: 'examen',
            path: '/examen/:examen',
            meta: { title: 'Examen' },
            component: () => import('@/views/examen/Examen')
        },
        {
            name: 'cursos',
            path: '/cursos',
            meta: { title: 'Cursos' },
            component: () => import('@/views/cursos/Cursos')
        },
        {
            name: 'curso',
            path: '/curso/:curso?',
            meta: { title: 'Curso' },
            component: () => import('@/views/cursos/Curso')
        },
        {
            name: 'cursos-categorias',
            path: '/cursos-categorias',
            meta: { title: 'Categorias de Cursos' },
            component: () => import('@/views/cursos/Categorias')
        },
        {
            name: 'categoria-cursos',
            path: '/cursos-categorias/:categoria',
            meta: { title: 'Cursos de Categoria' },
            component: () => import('@/views/cursos/Categoria')
        },
        {
            name: 'cursos-especialidades',
            path: '/cursos-especialidades',
            meta: { title: 'Especialidades de Cursos' },
            component: () => import('@/views/cursos/Especialidades')
        },
        {
            name: 'especialidad-cursos',
            path: '/cursos-especialidades/:especialidad',
            meta: { title: 'Cursos de Especialidad' },
            component: () => import('@/views/cursos/Especialidad')
        },
        {
            name: 'evaluaciones',
            path: '/cursos/evaluaciones',
            meta: { title: 'Evaluaciones del Aula' },
            component: () => import('@/views/cursos/Evaluaciones')
        },
        {
            name: 'grupos',
            path: '/grupos',
            meta: { title: 'Grupos' },
            component: () => import('@/views/roles/Roles')
        },
        {
            name: 'posters',
            path: '/posters',
            meta: { title: 'Posters' },
            component: () => import('@/views/posters/Posters')
        },
        {
            name: 'facturas',
            path: '/facturas',
            meta: { title: 'Facturas' },
            component: () => import('@/views/facturas/Facturas')
        },
        {
            name: 'leads-digital',
            path: '/leads-digital',
            meta: { title: 'Leads Digitales' },
            component: () => import('@/views/tareas/lead-digital/LeadsList')
        },
        {
            name: 'cobranzas',
            path: '/cobranzas',
            meta: { title: 'Cobranzas' },
            component: () => import('@/views/tareas/cobranza/CobranzasList')
        },
        {
            name: 'cobranza',
            path: '/cobranzas/:cobranza',
            meta: { title: 'Cobranza' },
            component: () => import('@/views/tareas/cobranza/CobranzaEdit')
        },
        {
            name: 'skypark',
            path: '/alianzas/skypark',
            meta: { title: 'Skypark' },
            component: () => import('@/views/alianzas/Skypark')
        },
        {
            name: 'sadasi',
            path: '/alianzas/sadasi',
            meta: { title: 'Sadasi' },
            component: () => import('@/views/alianzas/Sadasi')
        },
        {
            name: 'ihm',
            path: '/alianzas/ihm',
            meta: { title: 'IHM' },
            component: () => import('@/views/alianzas/IHM')
        },
        {
            name: 'monte-de-piedad',
            path: '/alianzas/monte-de-piedad',
            meta: { title: 'Monte de Piedad' },
            component: () => import('@/views/alianzas/MonteDePiedad')
        },
        {
            name: 'onisvida',
            path: '/alianzas/onisvida',
            meta: { title: 'OnisVida' },
            component: () => import('@/views/alianzas/OnisVida')
        },
        {
            name: 'hsbc',
            path: '/alianzas/hsbc',
            meta: { title: 'HSBC' },
            component: () => import('@/views/alianzas/HSBC')
        },
        {
            name: 'bienparabien',
            path: '/alianzas/bienparabien',
            meta: { title: 'Bien para bien' },
            component: () => import('@/views/alianzas/Bienparabien')
        },
        {
            name: 'red',
            path: '/red',
            meta: { title: 'Red de Promotores' },
            component: () => import('@/views/red/RedList')
        },
        {
            name: 'aplicaciones',
            path: '/aplicaciones',
            meta: { title: 'Aplicaciones' },
            component: () => import('@/views/aplicaciones/AplicacionesTable')
        },
        {
            name: 'venta-inmuebles',
            path: '/venta-inmuebles',
            meta: { title: 'Venta de Inmuebles' },
            component: () => import('@/views/tareas/venta-inmuebles/TareasTable')
        },
        {
            name: 'producto-credito',
            path: '/producto-credito',
            meta: { title: 'Productos de Crédito' },
            component: () => import('@/views/tareas/producto-credito/TareasTable')
        },
        {
            name: 'solicitudes-producto',
            path: '/productos/:producto',
            meta: { title: 'Solicitudes Producto' },
            component: () => import('@/views/productos/SolicitudesProducto.vue')
        },
        {
            name: 'solicitud-producto-detalle',
            path: '/productos/:producto/solicitudes/:solicitud',
            meta: { title: 'Solicitudes Producto' },
            component: () => import('@/views/productos/DetalleSolicitud.vue')
        },
    ]),
    {
        path: '*',
        meta: { layout: 'base', title: 'Oops! Hubo un error.' },
        component: () => import('@/views/error/NotFound404')
    }
]